import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Copy } from '../../stateless/copy';
import { AnswersRange } from '../../stateless/answers';
import { NextButton } from '../../stateless/buttons';
import HOCNextStepController from '../../hoc/next-step-controller';
import EconomicalScoreTracker from '../../shared/economical-score-tracker';
import EconomicalScoreTrackerFourPlayer from '../../shared/economical-score-tracker-four-participants';
import EconomicalScoreTrackerFourPlayerTakeFromPool
	from '../../shared/economical-score-tracker-four-participants-take-from-pool';
import EconomicalScoreTrackerInputReturn from '../../shared/economical-score-tracker-input-return';
import ReviewResults from '../../shared/review-results';
import EconomicalScoreTrackerFourPlayerTutorial from '../../shared/economical-score-tracker-four-participants-tutorial';

const EnhancedButton = HOCNextStepController(NextButton);

export default class EconomicalRange extends Component {

	static PropTypes = {
		user: PropTypes.object,
		players: PropTypes.object,
		window: PropTypes.object,
		nextWindow: PropTypes.func,
		updateAnswer: PropTypes.func,
		updateSaveState: PropTypes.func,
		currentValue: PropTypes.string,
		countryCode: PropTypes.string
	};

	constructor (props) {
		super(props)
		this.hasResources = true;
		this.hasRewards = false;
	}

	componentWillReceiveProps (nextProps) {
		if (this.props.currentValue !== nextProps.currentValue) {
			this.calculateResult(nextProps);
		}
	}

	calculateResult (newProps) {
		const { max } = newProps.window.current.answers.range;
		const players = newProps.window.current.players || Object.keys(this.props.players);
		const { atLeast, poolResources, multiplier, playerBaseResources } = newProps.window.current.answers;

		let { currentValue } = newProps;
		let newState = {};

		for (let [key] of Object.entries(this.props.players)) {
			newState[key] = { resources: (playerBaseResources && playerBaseResources[key]) || 0 };
		}

		newState = this.rangeTypeSelector({
			max,
			players,
			atLeast,
			poolResources,
			playerBaseResources,
			currentValue,
			newState,
			multiplier
		});

		this.props.updateSaveState({ players: newState });
	}

	rangeTypeSelector (settings) {
		let { max, players, atLeast, currentValue, newState, poolResources } = settings;
		currentValue = parseInt(currentValue);

		switch (this.props.step) {
			case 'question-economical-tutorial' : {
				newState[players[0]].resources = 0;
				newState[players[1]].resources = 0;
				newState[players[2]].resources = 0;
				newState[players[3]].resources = 0;
				break;
			}
			case 'question-economical-03' :
			case 'question-economical-04' :
			case 'question-economical-05' :
			case 'question-economical-07' :
			case 'question-economical-09' : {
				if (!atLeast || currentValue > atLeast) {
					newState[players[0]].resources += max - currentValue;
					newState[players[1]].resources += currentValue;
				}
				break;
			}
			case 'question-economical-06' : {
				const poolTotal = poolResources + currentValue;
				const poolAfterProfit = poolTotal * 3;
				const profitPerPlayer = Math.round(poolAfterProfit / 4);

				this.hasRewards = true;

				newState[players[0]].resources += profitPerPlayer - currentValue;
				newState[players[1]].resources += profitPerPlayer - 7000;
				newState[players[2]].resources += profitPerPlayer - 5750;
				newState[players[3]].resources += profitPerPlayer - 3000;

				newState[players[0]].rewards = [];
				newState[players[1]].rewards = [];
				newState[players[2]].rewards = ['lighthouse'];
				newState[players[3]].rewards = [];

				break;
			}
			case 'question-economical-08' : {
				if (currentValue > 49) {
					newState[players[0]].resources += -2500;
					newState[players[1]].resources += -2500;
					newState[players[2]].resources += -2500;
					newState[players[3]].resources += -2500;
				} else {
					newState[players[0]].resources += (100 * currentValue);
					newState[players[1]].resources += 2200;
					newState[players[2]].resources += 2000;
					newState[players[3]].resources += 3100;
				}
				break;
			}
			case 'question-economical-10-02' : {
				const poolTotal = poolResources + currentValue;
				const poolAfterProfit = poolTotal * 2;
				const profitPerPlayer = Math.round(poolAfterProfit / 4);
				newState[players[0]].resources += profitPerPlayer - currentValue;
				newState[players[1]].resources += profitPerPlayer - 4500;
				newState[players[2]].resources += profitPerPlayer - 5000;
				newState[players[3]].resources += profitPerPlayer - 2500;
				break;
			}
			case 'question-economical-12' : {
				const totalCash = currentValue * 3;
				newState[players[0]].resources += Math.round(totalCash * 0.4) - currentValue;
				newState[players[1]].resources += Math.round(totalCash * 0.6);
				break;
			}
		}
		return newState;
	}

	scoreTracker () {
		let scoreTracker;

		switch (this.props.step) {
			case 'question-economical-tutorial' : {
				scoreTracker = <EconomicalScoreTrackerFourPlayerTutorial {...this.props} {...this.state} unit={'€'}
																																 multiplier={3} />
				break;
			}
			case 'question-economical-03' :
			case 'question-economical-04' :
			case 'question-economical-05' :
			case 'question-economical-07' :
			case 'question-economical-09' : {
				scoreTracker = <EconomicalScoreTracker {...this.props} {...this.state} />
				break;
			}
			case 'question-economical-06' : {
				scoreTracker = <EconomicalScoreTrackerFourPlayer {...this.props} {...this.state} unit={'€'}
																												 multiplier={3} />
				break;
			}
			case 'question-economical-08' : {
				scoreTracker = <EconomicalScoreTrackerFourPlayerTakeFromPool {...this.props} {...this.state} unit={'MW'}
																																		 isTake={true} />
				break;
			}
			case 'question-economical-10-02' : {
				scoreTracker = <EconomicalScoreTrackerFourPlayer {...this.props} {...this.state} unit={'€'}
																												 multiplier={2} />
				break;
			}
			case 'question-economical-12' : {
				scoreTracker = (
					<div>
						<EconomicalScoreTrackerInputReturn {...this.props} {...this.state} unit={'€'} />
					</div>
				)
				break;
			}
		}
		return scoreTracker;
	}

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		const { user, window, countryCode, updateAnswer, currentValue, players } = this.props;

		return (
			<div>
				<Copy user={user}
							window={window}
							countryCode={countryCode}
							players={players}>

					{this.scoreTracker()}

					{
						(window.current && window.current.reviewResults) &&
						<ReviewResults />
					}

					{
						window.current.answers &&
						<AnswersRange range={window.current.answers.range}
													updateAnswer={updateAnswer}
													currentValue={currentValue} />
					}

					<EnhancedButton
						{ ...this.props }
						hasResources={ this.hasResources }
						hasRewards={ this.hasRewards }
					/>
				</Copy>
			</div>
		)
	}
}
